<script>
    import { createEventDispatcher } from 'svelte';
    import { lang } from '../language';

    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let i18n = 'en';
    export let content = '';
    export let interestedText = '';
    export let notInterestedText = '';
    export let loading = false;

    //METHODS
    const accept = () => dispatch('accept');
    const refuse = () => dispatch('refuse');

    //VARIABLES
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_flex-justify-content-center">
    <div class="app-msi_form-column">
        {#if !loading}
            <div>{@html content}</div>
            <button
                on:click={() => accept()}
                class="app-msi_btn app-msi_btn-primary accept-btn"
                type="submit"
            >
                {interestedText}
            </button>

            <button
                on:click={() => refuse()}
                class="app-msi_btn app-msi_btn-primary refuse-btn"
                type="submit"
            >
                {notInterestedText}
            </button>
        {:else}
            {lang[i18n]?.loading || 'Loading...'}
        {/if}
    </div>
</div>
